import api from 'api';

const tokenManager = {
    getTokenFromCode(code, selfUrl) {
        return api.token.getTokenFromCode(code, selfUrl);
    },
};

export default tokenManager;
